export default (state) => state.user
  && state.user.data
  && state.user.data.userGroupRelations
